import { Injectable } from "@angular/core";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { Observable, catchError, map, of } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class FCMService {
    constructor(private afMessaging: AngularFireMessaging) {}

    requestPermission(): Observable<string> {
        return this.afMessaging.requestPermission.pipe(
            map((res: any) => {
                return res || "";
            }),
            catchError(() => {
                return of("");
            })
        );
    }

    requestToken(): Observable<string> {
        return this.afMessaging.requestToken.pipe(
            map((token: any) => {
                return token || "";
            }),
            catchError(() => {
                return of("");
            })
        );
    }

    // receiveMessage() {
    //     this.afMessaging.messages.subscribe((payload: any) => {
    //         console.log('Received message:', payload);
    //         this.currentMessage.next(payload);
    //     });
    // }
}
